import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=102974a9&scoped=true&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"
import style0 from "./particulars.vue?vue&type=style&index=0&lang=less&"
import style1 from "./particulars.vue?vue&type=style&index=1&id=102974a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102974a9",
  null
  
)

export default component.exports